import { render, staticRenderFns } from "./Temperatura.vue?vue&type=template&id=772c945b&scoped=true"
import script from "./Temperatura.vue?vue&type=script&lang=js"
export * from "./Temperatura.vue?vue&type=script&lang=js"
import style0 from "./Temperatura.vue?vue&type=style&index=0&id=772c945b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772c945b",
  null
  
)

export default component.exports